import Topbar from "../components/Topbar";
import axios from "axios";
import Avatar from "react-avatar";
import useCurrentUser from "../hooks/useCurrentUser";
import "../css/ProfilePage.css";
import Gallery from "../components/Gallery";
import { useEffect, useState } from "react";
import ArtworkMagnifier from "../components/ArtworkMagnifier";
import ManageEntityPopup from "../components/ManageEntityPopup";
import { ColorContext } from "../context/ColorContext";
import { useContext } from "react";
import { EntityManagementContext } from "../context/EntityManagementContext";

function Profile() {
    let user = null;
    user = useCurrentUser();

    // Same as the currently authenticated user? May want to refactor later on...
    const [artist, setArtist] = useState(null);

    // Classes associated with the user
    const [myClasses, setMyClasses] = useState([]);

    // Artwork currently expanded so that user can view details
    const [selectedArtwork, setSelectedArtwork] = useState(null);

    // Did the user click the button to edit their account?
    const [editingSelf, setEditingSelf] = useState(false);

    // What kind of user is this?
    const [entityType, setEntityType] = useState(null);

    const { blue, white } = useContext(ColorContext);

    // Select an artwork from the gallery
    const selectArtwork = (event) => {
        setSelectedArtwork(event.target);
    }

    // X out of the expanded artwork
    const closeArtwork = () => {
        setSelectedArtwork(null);
    }

    // Load user details
    // Could probably refactor some here....
    useEffect(() => {
        let endpoint;
        if (user) {
            if (user.is_staff) {
                if (user.is_superuser) {
                    endpoint = "admins";
                    setEntityType("Admin");
                } else {
                    endpoint = "teachers";
                    setEntityType("Teacher");
                }
            } else {
                endpoint = "students";
                setEntityType("Student");
            }

            axios.get("/api/" + endpoint + "/" + user.id)
                .then((response) => {
                    setArtist(response.data);
                    if (!user.is_superuser) {
                        axios.get("/api/" + endpoint + "/" + user.id + "/classes")
                            .then((response) => {
                                setMyClasses(response.data);
                            });
                    }
                });
        }
    }, [user]);

    // Show popup to edit account
    function editProfile() {
        setEditingSelf(true);
    }

    // Exit out of popup
    function exitPopup() {
        setEditingSelf(false);
    }

    // After a user updates their profile, set the artist info
    // to the new user object and close the popup
    //      newEntity: New or updated user object
    //      editedPassword: If true, user just edited their password
    function updateProfile(newEntity, editedPassword = false) {
        if (!editedPassword) {
            setArtist(newEntity);
            exitPopup();
        } else {
            // Reload window --> user is logged out when they
            // change their own password
            window.location.reload();
        }
    }

    // Values to be passed to the manage entity popup;
    // these look a little different from the values we
    // use in Admin.jsx
    const entityManagementContext = {
        exit: exitPopup,
        mode: "Edit",
        setMode: () => {},
        type: entityType,
        classes: [],
        teachers: [],
        editingID: artist && artist.id,
        updateEntities: updateProfile
    }

    return (
        <div class="page" id="profile-page">
            <Topbar mostUpdatedName={artist && `${artist.first_name} ${artist.last_name}`}/>
            <div id="profile-page-content">
                {selectedArtwork && (
                    <ArtworkMagnifier selectedArtwork={selectedArtwork} closeArtwork={closeArtwork} />
                )}
                {editingSelf && entityType != "Student" && artist.id != 1 && (
                    <EntityManagementContext.Provider value={entityManagementContext}>
                        <ManageEntityPopup/> 
                    </EntityManagementContext.Provider>
                )}
                {artist ? (
                    <div id="profile-page-inner-contents">
                        <div id="about-user" className="profile-panel">
                            {/* TODO: Create separate component for Avatar */}
                            <Avatar id="profile-pic" name={artist.first_name + " " + artist.last_name} round={true} size="50" color={blue} fgColor={white} /> {/* Profile picture */}
                            <h1>{artist.first_name + " " + artist.last_name}</h1>
                            <p id="user-email">{artist.email}</p>
                            {entityType != "Student" && artist.id != 1 &&
                                <button onClick={editProfile}>Edit My Profile</button>
                            }
                            {!artist.is_superuser && (
                                <h2>My Classes</h2>
                            )}
                            <div id="classes">{!artist.is_superuser ? 
                                (myClasses.map((myClass) => 
                                    (<p className="class">
                                        {myClass.className}
                                    </p>)))
                            : (null)}</div>
                        </div>
                        <div id="user-images" className="profile-panel">
                            <Gallery artist={artist} artSelector={selectArtwork} closeArtwork={closeArtwork} />
                        </div>
                    </div>
                ) : (null)}
            </div>
        </div>
    )
}

export default Profile;
